import React from 'react';
import { observer, inject } from 'mobx-react';

import { Droppable, Draggable } from 'react-beautiful-dnd';

import { injectIntl } from 'react-intl';
import { Row, Col, Panel } from 'react-bootstrap';

import BlockHeader from './BlockHeader';
import BlockActions from './BlockActions';
import BlockBody from './BlockBody';
import BlockModal from './BlockModal';

@inject('rootStore')
@observer
class Block extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.canEdit = props.rootStore.authorizationStore.canEdit;
  }

  render() {
    const {
      blockStore,
      hideBlockAction,
      stepByStep,

      toggleWideScreen,
      toggled
    } = this.props;
    const noAddButtonClass = this.canEdit ? '' : 'no-button';

    return (
      <div
        className={`lane lane-${blockStore.name} ${noAddButtonClass} ${
          toggled ? 'expanded-lane' : ''
        }`}
      >
        <Panel className="">
          <Col xs={12} className="bmc-col-lane">
            <div className="lane-list-container">
              <BlockHeader blockStore={blockStore} />

              <div style={{ display: 'flex' }}>
                {!hideBlockAction && <BlockActions blockStore={blockStore} />}
                {toggleWideScreen &&(
                <button
                  className="btn btn-default margin-10Bottom"
                  onClick={() => toggleWideScreen(blockStore.name)}
                >  
                  <span
                    className={`glyphicon glyphicon-resize-${
                      toggled ? 'small' : 'full'
                    }`}
                  />
                </button>
)
                }
              </div>

              <BlockModal blockStore={blockStore} />

              <Droppable
                droppableId={String(
                  blockStore.rootStore.blocks.indexOf(blockStore)
                )}
                type="BLOCK_BODY"
              >
                {(provided, snapshot) => (
                  <BlockBody
                    blockStore={blockStore}
                    provided={provided}
                    snapshot={snapshot}
                  />
                )}
              </Droppable>
            </div>
          </Col>
        </Panel>
      </div>
    );
  }

  // handleBlockActionAddClick() {
  //     this.setState({showBlockModal: !this.state.showBlockModal})
  // }
}

export default injectIntl(Block);
